import { render, staticRenderFns } from "./AppCollectionLink.vue?vue&type=template&id=83a273dc&scoped=true&"
import script from "./AppCollectionLink.vue?vue&type=script&lang=js&"
export * from "./AppCollectionLink.vue?vue&type=script&lang=js&"
import style0 from "./AppCollectionLink.vue?vue&type=style&index=0&id=83a273dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a273dc",
  null
  
)

export default component.exports